import { db } from '@/database/firebase.db';
import { IUser } from '@/models/IUser.model';

export class UsersAPI {

    private db;
    private collection;

    constructor() {
        this.db = db;
        this.collection = this.db.collection('users');
    }

    async post(user: IUser): Promise<IUser | null> {

        // Add User
        const userId = user.cc_type + '_' + user.cc_number;
        const userQuery = this.collection.doc(userId);
        const userSnapshot = await userQuery.set(user);


        // Update Summary
        try {
            const usersQuery = this.collection.doc('SUMMARY');
            const usersSnapshot = await usersQuery.get();
            const usersDocument = usersSnapshot.data();
            if (usersDocument) {
                const summaryUsers = usersDocument;
                summaryUsers[userId] = user;
                console.log(summaryUsers)
                await this.collection.doc('SUMMARY').set(summaryUsers);
            } else {
                throw 'Error Updating User.Summary'
            }
        } catch (err) {
            console.log(' Users.api userSnapshot ')
            console.log(userSnapshot)
            console.error(err)
        }

        return user;
    }
    async patch(user: IUser): Promise<IUser | null> {

        // Add User
        const userId = user.cc_type + '_' + user.cc_number;
        const userQuery = this.collection.doc(userId);
        const userSnapshot = await userQuery.update(user);

        // Update Summary
        const usersQuery = this.collection.doc('SUMMARY');
        const usersSnapshot = await usersQuery.get();
        const usersDocument = usersSnapshot.data();
        if (usersDocument) {
            const summaryUsers = usersDocument;
            summaryUsers[userId] = user;
            await this.collection.doc('SUMMARY').set(summaryUsers);
        } else {
            throw 'Error Updating User.Summary'
        }
        return user;
    }

    async getAll(): Promise<IUser[]> {
        const usersQuery = this.collection.doc('SUMMARY');
        const usersSnapshot = await usersQuery.get();
        const usersDocument = usersSnapshot.data();
        if (usersDocument) {
            return Object.values(usersDocument);
        } else {
            return []
        }
    }

    async getByCC(cc: string): Promise<IUser | null> {
        const usersQuery = this.collection.where('cc_number', '==', cc + '');;
        const usersSnapshot = await usersQuery.get();
        const userDocument = usersSnapshot.docs[0];
        if (userDocument) {
            const userR = userDocument.data();
            const user: IUser = userR as IUser;
            return user;
        } else {
            return null
        }
    }
} 